import { render } from "./Line.vue?vue&type=template&id=edb0484a&scoped=true"
import script from "./Line.vue?vue&type=script&lang=js"
export * from "./Line.vue?vue&type=script&lang=js"

import "./Line.vue?vue&type=style&index=0&id=edb0484a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-edb0484a"

export default script